import { createContentPropTypes } from '../../../../helpers/content';

const content = {
	header: 'Payment date unavailable',
	description:
		'Sorry, international payments can’t be processed on weekends or bank holidays (either in the UK or the country you’re sending money to).',
	dateNoteDescription:
		'If this is a future-dated payment and you’d like the payee to receive it earlier, you could try editing the date to see if earlier settlement dates are available.',
	settlementDateTitle: 'We’ve updated your settlement date to the next available business banking day:',
	oKButtonTitle: 'OK, got it',
};

export const contentPropTypes = createContentPropTypes(content);
export default content;
